export const DRAG_N_DROP_HANDLE_ATTR_NAME = "data-drag-n-drop-handle";
export const CLONED_ELEMENT_ID = "cloned-element-for-photos-section-mouse-drag-event";

export const MOUSE_MOVE_SENSITIVITY_THRESHOLD_PX = 2;
export const TOUCH_MOVE_SENSITIVITY_THRESHOLD_PX = 2;
export const TOUCH_DRAG_START_TIMEOUT_MS = 150;

export const DETECT_INTERSECTION_THROTTLE_TIMEOUT_MS = 100;

export const SCROLL_THRESHOLD_PX = 50;

export const SCROLL_SPEED_PX = 50;
export const SCROLL_INTERVAL_MS = 50;

export const CHECK_IS_SCROLLING_NEEDED_THROTTLE_TIMEOUT_MS = 100;

export const SET_ELEM_WITH_SIZE_AND_COORD_LIST_DEBOUNCE_MS = 200;
